import { Resizable } from 're-resizable';
import { useEffect, useState } from 'react';

const VerticalBar = () => (
  <div className="vertical_bar">
    <div>
      <i className="fas fa-bars" />
    </div>
  </div>
);
const HorizontalBar = () => (
  <div className="horizontal_bar">
    <div>
      <i className="fas fa-bars" />
    </div>
  </div>
);

type Props = {
  /** 有効方向 */
  enabled: Partial<{
    top: boolean;
    right: boolean;
    bottom: boolean;
    left: boolean;
  }>,
  /** 対象Component */
  children: HTMLElement | globalThis.JSX.Element;
  maxHeight?: number | string;
  maxWidth?: number;
  minHeight?: number | string;
  minWidth?: number;
  size?: string;
}

/* 対象のサイズを自由に操作する */
export const Resize = (props: Props) => {
  const {
    enabled,
    children,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    size,
  } = props;
  const {
    top,
    right,
    bottom,
    left,
  } = enabled;

  const [_size, setSize] = useState(size || '');

  useEffect(() => {
    setSize(size || '');
  }, [size]);

  useEffect(() => {
    if (_size !== '') {
      setSize('');
    }
  }, [_size]);

  return (
    <Resizable
      className="resize"
      enable={{ ...enabled }}
      handleComponent={{
        top: top ? <HorizontalBar /> : undefined,
        bottom: bottom ? <HorizontalBar /> : undefined,
        right: right ? <VerticalBar /> : undefined,
        left: left ? <VerticalBar /> : undefined,
      }}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      minHeight={minHeight}
      minWidth={minWidth}
      size={{
        width: '',
        height: _size || '',
      }}
    >
      {children}
    </Resizable>
  );
};
